export default __webpack_public_path__ + "static/media/landingpageback.f17225fa.png";